import { reducer, streamReducer } from '@ardoq/rxbeach';
import {
  closePresentation,
  openPresentationBuilder,
  setPresentationInListMode,
} from './actions';
import { PresentationOverviewStreamShape } from './types';
import { APICurrentUser, ArdoqId, PersonalSetting } from '@ardoq/api-types';
import { createPresentationAndOpenInPreview } from 'streams/presentations/actions';
import { dishonestCurrentUser$ as currentUser$ } from '../../streams/currentUser/currentUser$';
import {
  presentationEditorClosed,
  presentationEditorOpened,
} from 'presentationEditor/actions';
import {
  togglePresentationEditor,
  TogglePresentationEditorPayload,
} from 'appContainer/actions';

export const defaultState: PresentationOverviewStreamShape = {
  isInListMode: false,
  isCreatingNewPresentation: false,
  isSavingNewPresentation: false,
  newPresentationFolderId: null,
};

const handleSetPresentationInListMode = (
  state: PresentationOverviewStreamShape,
  isInListMode: boolean
): PresentationOverviewStreamShape => {
  return {
    ...state,
    isInListMode,
  };
};

export const handleOpenPresentationBuilder = (
  state: PresentationOverviewStreamShape,
  newPresentationFolderId: ArdoqId | null
): PresentationOverviewStreamShape => {
  return {
    ...state,
    isCreatingNewPresentation: true,
    isSavingNewPresentation: false,
    newPresentationFolderId,
  };
};

export const handleStopCreatingNewPresentation = (
  state: PresentationOverviewStreamShape
): PresentationOverviewStreamShape => {
  return {
    ...state,
    isCreatingNewPresentation: false,
    isSavingNewPresentation: false,
    newPresentationFolderId: null,
  };
};

export const handleTogglePresentationEditor = (
  state: PresentationOverviewStreamShape,
  { shouldShow }: TogglePresentationEditorPayload
): PresentationOverviewStreamShape => {
  if (shouldShow) return state;
  return handleStopCreatingNewPresentation(state);
};

const handleCreatingPresentation = (
  state: PresentationOverviewStreamShape
): PresentationOverviewStreamShape => {
  return {
    ...state,
    isSavingNewPresentation: true,
  };
};

const handleCurrentUserChange = (
  state: PresentationOverviewStreamShape,
  currentUser: APICurrentUser
) => {
  const presentationOverViewSettings =
    currentUser.settings[PersonalSetting.PRESENTATION_OVERVIEW_STATE];
  const { isInListMode } = presentationOverViewSettings ?? state;

  return { ...state, isInListMode };
};

export const reducers = [
  reducer(setPresentationInListMode, handleSetPresentationInListMode),
  reducer(openPresentationBuilder, handleOpenPresentationBuilder),
  reducer(closePresentation, handleStopCreatingNewPresentation),
  reducer(presentationEditorOpened, handleStopCreatingNewPresentation),
  reducer(presentationEditorClosed, handleStopCreatingNewPresentation),
  reducer(togglePresentationEditor, handleTogglePresentationEditor),
  reducer(createPresentationAndOpenInPreview, handleCreatingPresentation),
  streamReducer(currentUser$, handleCurrentUserChange),
];
